import { render } from "./BoardNoticeCreateForm.vue?vue&type=template&id=3725e405&lang=true"
import script from "./BoardNoticeCreateForm.vue?vue&type=script&lang=js"
export * from "./BoardNoticeCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__